import { Deserializable } from '../interfaces/deserialize';
import * as _ from 'lodash';

export class CustomerModel implements Deserializable {
  // tslint:disable-next-line:variable-name
  _id?: string;
  cif!: string;
  companyModality!: string;
  status!: string;
  businessName!: string;
  billingAddress!: string;
  country!: string;
  name?: string;
  surnames!: string;
  product!: string;
  position?: string;
  phoneNumber!: string;
  email!: string;
  password!: string;
  createdAt?: string;
  updatedAt?: string;
  newsletterAccepted?: boolean | string;

  deserialize(obj: any) {
    Object.assign(this, obj);
    return this;
  }
}
